import request from '@/utils/request';
import type {
  FetchAnalyticsResp,
  FetchTourOrderAnalyticsResp,
} from '@/pages/Analytics/analytics.data';

export async function fetchAnalytics(params?: any): Promise<FetchAnalyticsResp> {
  return request.get('/cms/analytics', {
    params,
  });
}

export async function fetchTopTourSell(params?: any): Promise<FetchAnalyticsResp> {
  return request.get('/cms/analytics/top-tour-sell', {
    params,
  });
}

export async function _fetchAnalytics(params?: any): Promise<FetchAnalyticsResp> {
  return request.get('/cms/analytics', {
    params,
  });
}

export async function fetchDashboardAnalytics(params?: any): Promise<FetchAnalyticsResp> {
  return request.get('/cms/analytics/dashboard', {
    params,
  });
}

export async function fetchTourOrderAnalytics(params?: any): Promise<FetchTourOrderAnalyticsResp> {
  return request.get('/cms/analytics/tour-order', {
    params,
  });
}

export async function fetchVisaOrderAnalytics(params?: any): Promise<FetchTourOrderAnalyticsResp> {
  return request.get('/cms/analytics/visa-order', {
    params,
  });
}

export async function fetchHotelOrderAnalytics(params?: any): Promise<FetchTourOrderAnalyticsResp> {
  return request.get('/cms/analytics/hotel-order', {
    params,
  });
}

export async function fetchComboOrderAnalytics(params?: any): Promise<FetchTourOrderAnalyticsResp> {
  return request.get('/cms/analytics/combo-order', {
    params,
  });
}

export async function fetchCostAnalytics(params?: any): Promise<FetchTourOrderAnalyticsResp> {
  return request.get('/cms/analytics/cost', {
    params,
  });
}
